import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as Types from 'helpers/types';
import pharmacy from 'services/pharmacy';

export default () => {
  const dispatch = useDispatch();
  const orderHistory = useSelector((state) => state.orderHistory);
  const [order, setOrder] = useState(null);

  useEffect(() => {
    const getOrders = async () => {
      try {
        dispatch({ type: Types.ORDER_HISTORY_LOADING });
        const response = await pharmacy.get('/patients/orders', {
          headers: { 'manual-orders': 'true', 'pharmacy-delivery-orders': 'true', 'api-version' : 'v2' },
        });
        dispatch({ type: Types.ORDER_HISTORY_SUCCESS, payload: response.data });
      } catch (e) {
        dispatch({ type: Types.ORDER_HISTORY_ERROR, payload: e });
      }
    };

    getOrders();
  }, [dispatch]);

  const getOrderById = (id) => {
    const individualOrder = orderHistory.orders.find((o) => o.order_id === id);
    if (individualOrder)
      individualOrder.order_statuses.sort(function (a, b) {
        return new Date(b.timestamp) - new Date(a.timestamp);
      });
    setOrder(individualOrder);
  };

  return [order, getOrderById];
};
